export default __webpack_public_path__ + "locales/pt/Translations.json?hash=bf483610b6a7f549e83c4ed86724efb8";